const STORAGE_KEY = "rm_cookie_consent";

export type ConsentChoice = "granted" | "denied";

/** Google Consent Mode v2 signals; the Meta pixel tag in GTM is gated on ad_storage. */
const signals = (choice: ConsentChoice) => ({
  ad_storage: choice,
  ad_user_data: choice,
  ad_personalization: choice,
  analytics_storage: choice,
});

export const readConsent = (): ConsentChoice | null => {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value === "granted" || value === "denied" ? value : null;
  } catch {
    return null;
  }
};

export const saveConsent = (choice: ConsentChoice) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, choice);
  } catch {
    // Private mode or blocked storage: the choice only lasts for this page view
  }
};

export const consentSignals = signals;
